import React from 'react';
import { Globe } from 'lucide-react';
import ModulePage from './ModulePage';

const scanChecks = (w) => [
  { label: 'Website bereikbaar', passed: !!w.reachable, detail: w.reachable ? 'Website laadt correct' : 'Website niet bereikbaar!' },
  { label: 'SSL-certificaat (HTTPS)', passed: !!w.has_ssl, detail: w.has_ssl ? 'Veilige verbinding actief' : 'Geen HTTPS — browsers tonen waarschuwing' },
  { label: 'Mobiel-vriendelijk', passed: !!w.has_viewport, detail: w.has_viewport ? 'Viewport meta tag aanwezig' : 'Niet geoptimaliseerd voor mobiel' },
  { label: 'Laadsnelheid', passed: (w.response_time_ms || 5000) < 2500, detail: w.response_time_ms ? `${w.response_time_ms}ms` : 'Niet gemeten' },
  { label: 'Analytics geinstalleerd', passed: !!w.has_analytics, detail: w.has_analytics ? 'Tracking actief' : 'Geen analytics — u vliedt blind' },
];

export default function WebsitePage() {
  return (
    <ModulePage
      category="website"
      title="Website"
      subtitle="Technische gezondheid en prestaties van uw website"
      icon={Globe}
      color="#3b82f6"
      scanChecks={scanChecks}
    />
  );
}
